import React from 'react';
import { Chip } from '@mui/material';

type Props = {
  stateCode?: string;
  current?: boolean;
};

const colorFor = (
  stateCode?: string,
): 'default' | 'primary' | 'success' | 'warning' | 'info' => {
  switch ((stateCode || '').toUpperCase()) {
    case 'ACTIVE': return 'success';
    case 'REVIEWED': return 'info';
    case 'DRAFT': return 'warning';
    case 'SUPERSEDED': return 'default';
    case 'ARCHIVED': return 'default';
    default: return 'primary';
  }
};

export default class BudgetControlStatusChip extends React.PureComponent<Props> {
  render() {
    const state = (this.props.stateCode || 'UNKNOWN').toUpperCase();
    const label = this.props.current ? `${state} · CURRENT` : state;

    return (
      <Chip
        size="small"
        variant={this.props.current ? 'filled' : 'outlined'}
        color={colorFor(state)}
        label={label}
      />
    );
  }
}
